import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { Logo } from "./Logo";
import { PHONE_DISPLAY, PHONE_TEL, scrollToSection } from "../constants/content";

const NAV = [
    { label: "How It Works", id: "how-it-works" },
    { label: "Reviews", id: "reviews" },
    { label: "Areas", id: "areas" },
    { label: "FAQ", id: "faq" },
];

export const Header = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-white/85 backdrop-blur-xl border-b border-[#E3E3DE]"
                    : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between gap-4">
                <Logo />

                <div
                    data-testid="header-availability-pill"
                    className="hidden xl:flex items-center gap-2 rounded-full border border-[#E3E3DE] bg-[#F4F4F2] px-4 py-1.5"
                >
                    <span className="h-2 w-2 rounded-full bg-emerald-400 animate-blink" />
                    <span className="font-mono-ind text-[11px] uppercase tracking-widest text-[#565B6B]">
                        Drivers active in Toronto &amp; GTA
                    </span>
                </div>

                <nav className="hidden lg:flex items-center gap-7">
                    {NAV.map((item) => (
                        <button
                            key={item.id}
                            data-testid={`nav-${item.id}`}
                            onClick={() => scrollToSection(item.id)}
                            className="text-sm font-semibold text-[#565B6B] hover:text-[#FF3B30] transition-colors duration-300"
                        >
                            {item.label}
                        </button>
                    ))}
                </nav>

                <a
                    href={PHONE_TEL}
                    data-testid="header-call-button"
                    className="flex items-center gap-2 rounded-md bg-[#FF3B30] px-4 sm:px-5 py-2.5 font-display font-bold text-sm text-white uppercase tracking-wide transition-all duration-300 hover:bg-[#E0342B] hover:shadow-[0_0_28px_rgba(255,184,0,0.35)]"
                >
                    <Phone className="h-4 w-4" strokeWidth={2.6} />
                    <span className="hidden sm:inline">{PHONE_DISPLAY}</span>
                    <span className="sm:hidden">Call Now</span>
                </a>
            </div>
        </header>
    );
};
